import React from 'react';
import { useCopyToClipboard } from "@uidotdev/usehooks";
import { messages } from '@/helpers/index';

export default function ClipboardCopy({ value, setCopied, children }) {
  const [copiedText, copyToClipboard] = useCopyToClipboard();
  const hasCopiedText = Boolean(copiedText);
  const handleCopy = (value) => {
    copyToClipboard(value);
    if (setCopied) {
      setCopied(true);
    }
    messages.message(`<strong>${value}</strong> copiado com sucesso.`, 'info', false, true, 'Área de Transferência');
  };
  return (
    <span className="cursor-pointer" onClick={() => handleCopy(value)}>
      {children}
    </span>
  );
}
